<template>
  <div>
    <vs-button
      @click="popupActive = true"
      color="success"
      icon-pack="feather"
      icon="icon-user-plus"
      :class="btnClass"
    >
    {{btnText}}</vs-button>
    <vs-popup :active.sync="popupActive" :title="title" >
      <div :id="`${name}-loading`" class="vs-con-loading__container">
        <form @submit.prevent="submitForm" class="px-2">
          <vs-row class="mb-2">
            <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
              <span>Category</span>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="9" vs-lg="9">
              <vs-input placeholder="category" v-model="category.name" class="w-full" disabled />
            </vs-col>
          </vs-row>

          <vs-row class="mb-2">
            <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
              <span>{{$t('name')}}</span>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="9" vs-lg="9">
              <vs-input :placeholder="$t('name')" v-model="formData.name" class="w-full" />
            </vs-col>
          </vs-row>

          <vs-row class="mb-2">
            <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
              <span>{{$t('rfc')}}</span>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="9" vs-lg="9">
              <vs-input :placeholder="$t('rfc')" v-model="formData.rfc" class="w-full" @input="v => { formData.rfc = v.toUpperCase() }" />
            </vs-col>
          </vs-row>

          <vs-row class="mb-2">
            <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
              <span>{{$t('email')}}</span>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="9" vs-lg="9">
              <vs-input type="email" :placeholder="$t('email')" v-model="formData.email" class="w-full" @keypress="validateEmail($event)"/>
            </vs-col>
          </vs-row>

          <vs-row vs-type="flex" vs-justify="flex-end">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-xs="12"
              vs-sm="3"
              vs-lg="3"
            >
              <vs-button class="w-full mx-2" type="border" @click="close">Cancel</vs-button>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-xs="12"
              vs-sm="3"
              vs-lg="3"
            >
              <vs-button
                class="w-full mx-2 "
                type="filled"
                color="success"
                @click.prevent="submitForm"
                :disabled="!isValid"
              >Submit</vs-button>
            </vs-col>
          </vs-row>
        </form>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vendor from '@/http/requests/vendor'
export default {
  props:{
    name:{
      type:String,
      name:'add-vendor'
    },
    btnClass:{
      type:String
    },
    btnText:{
      type:String
    },
    title:{
      type:String
    },
    category:{
      default:() => ({ id:'00',name:''})
    }
  },
  data: function() {
    return {
      defaultForm: {
        category:'',
        name: '',
        rfc: '',
        email: ''
      },
      formData: {
        category:'',
        name: '',
        rfc: '',
        email: ''
      },
      popupActive: false
    }
  },
  watch: {
    popupActive(val) {
      if (val) {
        this.formData = Object.assign({}, this.defaultForm)
      }
    }
  },
  computed: {
    isValid() {
      return (
        this.formData.name !== '' &&
        this.formData.rfc !== '' &&
        this.formData.email !== ''
      )
    }
  },
  methods: {
    textToUpper(val) {
      this.formData.rfc = val.toUpperCase()
    },
    validateEmail (event) {
      if (this.formData.email !== '') {
        if (this.formData.email.length >= 50) {
          event.preventDefault()
        }
      }
    },
    openLoading() {
      this.$vs.loading({
        container: `#${this.name}-loading`,
        scale: 0.6
      })
    },
    closeLoading() {
      this.$vs.loading.close(`#${this.name}-loading > .con-vs-loading`)
    },
    close() {
      this.popupActive = false
    },
    submitForm() {
      this.openLoading()
      this.formData.category = this.category.id
      //this.formData.rfc = this.formData.rfc.
      this.$store.dispatch('compliance/addVendor', this.formData)
        .then(res => {
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Item Added'
          })
          this.$emit('success',res.item.id)
          this.closeLoading()
          this.close()
        })
        .catch(err => {
          this.closeLoading()
          if (422 === err.response.status) {
            let errors = err.response.data.errors
            let errorArray = Object.keys(errors).map(function(key) {
              return [key, errors[key]]
            })
            errorArray.forEach(element => {
              this.$vs.notify({
                color: 'danger',
                title: 'Alert',
                text: element[1][0]
              })
            })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Alert',
              text: 'SERVER ERROR'
            })
          }
        })
    }
  }
}
</script>


<style lang="css">
.input-uppercase .vs-con-input input{
    text-transform: uppercase;
}
</style>